import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../../../components/navbar';
import Footer from '../../../../components/footer';
import Button from '../../../../components/Button';
import Checkbox from '../../../../components/Checkbox';
import { useConsultation } from '../../../../context/ConsultationContext';
import { handleTreatmentServiceNavigation } from '../components/treatmentNavigationHelper';
import styles from './css/BloodPressure.module.css';
import newStyle from './css/DietPlusInjection.module.css';
import { Activity, Send, Syringe } from 'lucide-react';

const DietPlusInjection = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { consultationData, updateConsultationData, getStepDraft, setStepDraft, goToStep } = useConsultation();

    const patient = location?.state?.patient || consultationData?.patient || {};
    const patientName = `${patient?.firstname || ""} ${patient?.surname || ""}`.trim() || "Thandiwe Ndlovu";
    const profileNumber = patient?.profilenumber || "448896";
    const initials = `${patient?.firstname?.[0] || ""}${patient?.surname?.[0] || ""}`.toUpperCase() || "TN";

    // Measurements states
    const [weight, setWeight] = useState('');
    const [injectionGiven, setInjectionGiven] = useState('');

    // Side effects states
    const [sideEffects, setSideEffects] = useState({
        nausea: false,
        headache: false,
        injectionSiteReaction: false,
        other: false
    });

    // Other states
    const [clinicalNotes, setClinicalNotes] = useState('');

    const handleSideEffectChange = (key) => {
        setSideEffects((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const handleInvoice = () => {
        handleTreatmentServiceNavigation({
            location,
            navigate,
            consultationData,
            updateConsultationData,
            getStepDraft,
            setStepDraft,
            goToStep,
            serviceData: {
                diet_plus_injection: {
                    weight,
                    injectionGiven,
                    sideEffects,
                    clinicalNotes,
                },
            },
        });
    };

    useEffect(() => {
        document.body.classList.add(styles.hideSidebar);
        return () => {
            document.body.classList.remove(styles.hideSidebar);
        };
    }, []);

    return (
        <div className={styles.bloodPressureContainer}>
            <Navbar />

            <main className={styles.mainContent}>
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <div className={styles.headerIcon} aria-hidden="true">
                            <Syringe />
                        </div>
                        <h1 className={newStyle.title}>Diet Plus Injection</h1>
                    </div>

                    <div className={styles.patientCard}>
                        <div className={styles.avatar} aria-hidden="true">{initials}</div>
                        <div className={styles.patientText}>
                            <div className={styles.patientName}>{patientName}</div>
                            <div className={styles.patientMetaRow}>
                                <span className={styles.profileInfo}>Profile: {profileNumber}</span>
                                <span className={styles.dependentBadge}>Dependent</span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.sectionTitle}>MEASUREMENTS</div>
                        <div className={newStyle.readingsRow}>
                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Weight</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="number"
                                        value={weight}
                                        onChange={(e) => setWeight(e.target.value)}
                                        className={styles.readingInput}
                                    />
                                    <span className={styles.unit}>kg</span>
                                </div>
                            </div>

                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Injection Given</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="text"
                                        value={injectionGiven}
                                        onChange={(e) => setInjectionGiven(e.target.value)}
                                        className={styles.readingInput}
                                        placeholder='e.g., Saxenda 1.2mg'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.sectionTitle}>SIDE EFFECTS</div>
                        <div className={styles.sideEffectsList}>
                            <div className={styles.checkboxItem}>
                                <Checkbox
                                    id="nausea"
                                    checked={sideEffects.nausea}
                                    onChange={() => handleSideEffectChange('nausea')}
                                />
                                <label htmlFor="nausea" className={styles.checkboxLabel}>Nausea</label>
                            </div>

                            <div className={styles.checkboxItem}>
                                <Checkbox
                                    id="headache"
                                    checked={sideEffects.headache}
                                    onChange={() => handleSideEffectChange('headache')}
                                />
                                <label htmlFor="headache" className={styles.checkboxLabel}>Headache</label>
                            </div>

                            <div className={styles.checkboxItem}>
                                <Checkbox
                                    id="injectionSiteReaction"
                                    checked={sideEffects.injectionSiteReaction}
                                    onChange={() => handleSideEffectChange('injectionSiteReaction')}
                                />
                                <label htmlFor="injectionSiteReaction" className={styles.checkboxLabel}>Injection site reaction</label>
                            </div>

                            <div className={styles.checkboxItem}>
                                <Checkbox
                                    id="other"
                                    checked={sideEffects.other}
                                    onChange={() => handleSideEffectChange('other')}
                                />
                                <label htmlFor="other" className={styles.checkboxLabel}>Other</label>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.fieldLabel}>Clinical Notes</div>
                        <textarea
                            value={clinicalNotes}
                            onChange={(e) => setClinicalNotes(e.target.value)}
                            className={styles.clinicalNotes}
                            placeholder="Enter clinical notes..."
                            rows={6}
                        />
                    </div>

                    <div className={styles.cardFooter}>
                        <Button
                            onClick={handleInvoice}
                            className={styles.invoiceButton}
                            type="button"
                        >
                            <Send size={16} />
                            Invoice
                        </Button>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default DietPlusInjection;